export default __webpack_public_path__ + "static/media/photo4.a5090678.jpg";